import {Errors, FormValue, RadioboxGroup, SimpleRadiobox, TextInput} from '@startlibs/form'
import React, {useEffect, useRef} from 'react'
import {smoothScroll} from '@startlibs/utils'
import { useIntl} from 'react-intl'
import {IfLocale} from '../../hocs/IfLocale'
import { IntakeFormCard } from './PatientDetailsNew';

export const PrimaryConcernNew = ({title, subTitle, readOnly, scrollTo, NavigationButtons}) => {

  const headerRef = useRef()
  const intl = useIntl()

  useEffect(() => {
    if (scrollTo) {
      smoothScroll({target:headerRef.current,offset:-200})
    }
  },[])

  return <>
    <IntakeFormCard>
      <div>
      <h3 ref={headerRef}>{title}</h3>
      <p>{subTitle}</p>
      {/* //Diagnosis Field  */}
      <IfLocale not contains="LEGAL">
        <FormValue path="caseInfo.intakeDiagnosis">{intakeDiagnosis =>
          intakeDiagnosis !== null && <>
           <TextInput
              disabled={readOnly}
              path="caseInfo.intakeDiagnosis"
              label={intl.formatMessage({defaultMessage:"Please provide the primary diagnosis", description:"Primary concern intakeDiagnosis title"})}
              helpText={intl.formatMessage({defaultMessage:"(If unknown, please list unknown)", description:"Primary concern intakeDiagnosis help text"})}
              placeholder={intl.formatMessage({defaultMessage:"Ex. Rheumatoid Arthritis", description:"Primary concern intakeDiagnosis placeholder"})}
              mandatory
            />
          </> 
          }
        </FormValue>

      </IfLocale>
     
      <IfLocale not contains="LEGAL">
        <RadioboxGroup
          disabled={readOnly}
          mandatory
          label={intl.formatMessage({defaultMessage:"Has the patient been treated or had surgery for this condition before?", description:"Primary hasBeenTreatedOrSurgeryBefore concern title"})}
          horizontal
          path="caseInfo.hasBeenTreatedOrSurgeryBefore"
          framedBoxes
          wide
        >
          <SimpleRadiobox fieldValue={true} label={intl.formatMessage({defaultMessage:"Yes", description:"Yes"})} className='fs-exclude'/>
          <SimpleRadiobox fieldValue={false} label={intl.formatMessage({defaultMessage:"No", description:"No"})} className='fs-exclude'/>
        </RadioboxGroup>

        <FormValue path="caseInfo.hasBeenTreatedOrSurgeryBefore">{hasBeenTreatedOrSurgeryBefore =>
          hasBeenTreatedOrSurgeryBefore && <>
          <TextInput
            disabled={readOnly}
            textarea
            autoResize
            path="caseInfo.treatedOrSurgeryBeforeDescription"
            label={intl.formatMessage({defaultMessage:"If so, please describe", description:"Primary concern hasBeenTreatedOrSurgeryBefore description"})}
            placeholder={intl.formatMessage({defaultMessage:"Provide any relevant details here", description:"Primary concern hasBeenTreatedOrSurgeryBefore placeholder"})}
            className='fs-exclude'
          />
          </>}
        </FormValue>
        
        <FormValue path="caseInfo.hasNewDiagnosisChangedTreatmentOrRecommendation">{hasNewDiagnosisChangedTreatmentOrRecommendation =>
          hasNewDiagnosisChangedTreatmentOrRecommendation !== null && <>
            <RadioboxGroup
              disabled={readOnly}
              mandatory
              label={intl.formatMessage({defaultMessage:"Has there been a new diagnosis, changed treatment or other recommendation?", description:"Primary concern hasNewDiagnosisChangedTreatmentOrRecommendation title"})}
              horizontal
              path="caseInfo.hasNewDiagnosisChangedTreatmentOrRecommendation"
              framedBoxes
              wide
            >
              <SimpleRadiobox fieldValue={true} label={intl.formatMessage({defaultMessage:"Yes", description:"Yes"})} className='fs-exclude'/>
              <SimpleRadiobox fieldValue={false} label={intl.formatMessage({defaultMessage:"No", description:"No"})} className='fs-exclude'/>
            </RadioboxGroup>

            <FormValue path="caseInfo.hasNewDiagnosisChangedTreatmentOrRecommendation">{hasNewDiagnosisChangedTreatmentOrRecommendation =>
              hasNewDiagnosisChangedTreatmentOrRecommendation && <>
              <TextInput
                disabled={readOnly}
                textarea
                autoResize
                path="caseInfo.newDiagnosisChangedTreatmentOrRecommendationDescription"
                label={intl.formatMessage({defaultMessage:"Please describe", description:"Primary concern hasNewDiagnosisChangedTreatmentOrRecommendation description"})}
                placeholder={intl.formatMessage({defaultMessage:"Provide any relevant details here", description:"Primary concern hasNewDiagnosisChangedTreatmentOrRecommendation placeholder"})}
                className='fs-exclude'
              />
              </>}
            </FormValue>  
          </>}
        </FormValue>
      </IfLocale>

      <TextInput
        className='fs-exclude'
        disabled={readOnly}
        textarea
        autoResize
        path="caseInfo.clinicalSummary"
        label={intl.formatMessage({
          defaultMessage:"Please add a description of your request including a brief medical history, current treatment plan, specific questions you may have, and any other pertinent information.",
          description:"Patient CaseInfo clinical summary details label"
        })}
        placeholder={intl.formatMessage({defaultMessage:"Describe your request and provide any additional information here",description:"Patient CaseInfo clinical summary details placeholder"})}
        mandatory
      />
      </div>
      <Errors path="caseInfo" />
      <NavigationButtons/>
    </IntakeFormCard>
  </>
}
